/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Metapic Internal Payments API Documentation
 * <p>API documentation for Metapic internal APIs. This documentation covers payment-related endpoints including payment summaries, cost summaries, payout history, and general payment operations.</p>
      <h2>Authentication</h2>
      <p>This API uses <strong>Bearer Token</strong> authentication. You must include a valid token in the <strong>Authorization</strong> header with every request to access protected endpoints.</p>
      <h4>Example:</h4>
      <pre>Authorization: Bearer <i>your_token_here</i></pre>
      <p>*Replace <i>your_token_here</i> with your actual Bearer token. All API requests require this token for authentication.</p>
 * OpenAPI spec version: 1.0
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  PerformanceChart,
  PerformanceControllerGetChartParams,
  PerformanceControllerGetMetricsParams,
  PerformanceControllerGetSummaryParams,
  PerformanceMetrics,
} from '../metapicInternalPaymentsAPIDocumentation.schemas'

export const getPerformance = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * Returns daily aggregated metrics for an advertiser over the requested date range, together with a previous period for comparison. If previous_date_from and previous_date_to are not provided, the previous period is automatically derived with equal length.
   * @summary Time-series performance chart
   */
  const performanceControllerGetChart = (
    params: PerformanceControllerGetChartParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PerformanceChart>> => {
    return axiosInstance.get(`/performance/chart`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Returns the requested metrics aggregated over the date range for an advertiser, each with the same metric aggregated over a previous period for comparison. If previous_date_from and previous_date_to are not provided, the previous period is automatically derived with equal length. The previous value is omitted when filtering by campaign.
   * @summary Aggregated performance metrics
   */
  const performanceControllerGetMetrics = (
    params: PerformanceControllerGetMetricsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PerformanceMetrics>> => {
    return axiosInstance.get(`/performance/metrics`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Returns the requested metrics aggregated over the date range for an advertiser, each with the same metric aggregated over a previous period for comparison. If previous_date_from and previous_date_to are not provided, the previous period is automatically derived with equal length. The previous value is omitted when filtering by campaign.
   * @summary Aggregated performance metrics
   */
  const performanceControllerGetSummary = (
    params: PerformanceControllerGetSummaryParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PerformanceMetrics>> => {
    return axiosInstance.get(`/performance/summary`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  return {
    performanceControllerGetChart,
    performanceControllerGetMetrics,
    performanceControllerGetSummary,
  }
}
export type PerformanceControllerGetChartResult = AxiosResponse<PerformanceChart>
export type PerformanceControllerGetMetricsResult = AxiosResponse<PerformanceMetrics>
export type PerformanceControllerGetSummaryResult = AxiosResponse<PerformanceMetrics>
